/**
 * ====================================================================
 * CONFIGURATION UNIFIÉE PEELOCHAT DASHBOARD - VERSION SIMPLIFIÉE
 * ====================================================================
 */

// ====================================================================
// DÉTECTION DE L'ENVIRONNEMENT
// ====================================================================

// Vérification sécurisée de l'environnement
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// ====================================================================
// CONFIGURATION API PRINCIPALE
// ====================================================================

// URL de l'API principale - Direct vers l'API peelo.chat
export const apiBaseUrl = 'https://api.peelo.chat';

// ====================================================================
// CONFIGURATION E-COMMERCE
// ====================================================================

export const ecommerceApiBaseUrl = isLocalhost
  ? 'https://apicommerce.peelo.chat'
  : 'https://apicommerce.peelo.chat';

export const ecommerceDashboardUrl = isLocalhost
  ? 'https://admin.peelo.shop'
  : 'https://admin.peelo.shop';

export const mainDashboardUrl = isLocalhost
  ? 'https://localhost:8080'
  : 'https://dashboard.peelo.chat';

// ====================================================================
// CONFIGURATION JARVIS
// ====================================================================

export const jarvisApiBaseUrl = 'https://jarvis.aipeelo.xyz';

// ====================================================================
// CONFIGURATION CRYPTO
// ====================================================================

export const cryptoSecret = process.env.VUE_APP_CRYPTO_SECRET || 'peelo-dashboard-secret-key-2024';

// ====================================================================
// CONFIGURATION DE DÉVELOPPEMENT
// ====================================================================

export const isDevelopment = isLocalhost;
export const isProduction = !isLocalhost; 